import { useTranslation } from 'react-i18next';
import { Button, IconStartAdornment } from 'components/Button';
import { DocumentTitle } from 'components/DocumentTitle';
import { SignupV4EnterEmail } from 'domains/signupv4/Steps/Base/EnterEmail';
import { SignupV4EnteringInsurance } from 'domains/signupv4/Steps/Base/EnteringInsurance';
import { SignupV4EnteringSchedule } from 'domains/signupv4/Steps/Base/EnteringSchedule';
import { SignupV4EnterName } from 'domains/signupv4/Steps/Base/EnterName';
import { SignupV4EnterPhone } from 'domains/signupv4/Steps/Base/EnterPhone';
import { SignupV4EnterState } from 'domains/signupv4/Steps/Base/EnterState';
import { SignupV4EnterTarget } from 'domains/signupv4/Steps/Base/EnterTarget';
import { SignupV4EnteringMiniScreener } from 'domains/signupv4/Steps/Base/EnteringMiniScreener';
import { SignupV4ErrorStep } from 'domains/signupv4/Steps/Shared/ErrorStep';
import { SignupV4LoadingStep } from 'domains/signupv4/Steps/Shared/LoadingStep';
import { SignupContextV4 } from 'domains/signupv4/Wrapper/context';
import { DisplayTimezoneProvider } from 'domains/timezone/useDisplayTimezone';
import { ErrorBoundary } from '@sentry/react';
import { BoundaryErrorStep } from '../Steps/Shared/BoundaryErrorStep';

const BaseSignUpMachineWrapperV4: React.FC = () => {
  const { t } = useTranslation();

  const hasBack = SignupContextV4.useSelector(state => {
    // Prevent going back from the resumedStep
    return state.can({ type: 'back' }) && state.context.resumedStep !== state.value;
  });
  const { send } = SignupContextV4.useActorRef();

  return (
    <ErrorBoundary fallback={<BoundaryErrorStep />}>
    <div className="flex flex-col min-h-full items-center px-24 md:px-0">
      <DocumentTitle>{t('screener.pageTitle')}</DocumentTitle>
      <div className="max-w-[600px] w-full min-h-full self-center py-64 sm-d:py-40">
        {hasBack && (
          <Button
            variant="link"
            startAdornment={<IconStartAdornment name="AngleLeft" />}
            className="mb-24"
            onClick={() =>
              send({
                type: 'back',
              })
            }
          >
            {t('screener.backButton')}
          </Button>
        )}
        <SignupV4EnterState />
        <SignupV4EnterEmail />
        <SignupV4EnterName />
        <SignupV4EnterPhone />
        <SignupV4EnterTarget />
        <SignupV4EnteringInsurance />
        <SignupV4EnteringMiniScreener />
        <DisplayTimezoneProvider>
          <SignupV4EnteringSchedule />
        </DisplayTimezoneProvider>
        <SignupV4LoadingStep />
          <SignupV4ErrorStep />
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default BaseSignUpMachineWrapperV4;
